import React from "react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";

const WHATSAPP_NUMBER = "971567575811";

function Footer() {
  const whatsappLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Hi! I'd like to know more about Tripontourism desert safaris."
  )}`;

  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className="row g-5">
          <div className="col-12 col-md-4">
            <Link to="/" className={styles.brand}>
              <div className={styles.logoCircle}>
                <span role="img" aria-label="jeep">
                  🚙
                </span>
              </div>
              <span className={styles.brandName}>Tripontourism</span>
            </Link>
            <p className={styles.tagline}>
              Dubai's trusted desert safari specialists — dune bashing,
              camel rides, and unforgettable evenings under the stars.
            </p>
            <div className={styles.social}>
              <span aria-label="Facebook" role="img">
                📘
              </span>
              <span aria-label="Twitter" role="img">
                🐦
              </span>
              <span aria-label="YouTube" role="img">
                ▶️
              </span>
              <span aria-label="Instagram" role="img">
                📷
              </span>
            </div>
          </div>

          <div className="col-6 col-md-2">
            <h3 className={styles.heading}>Explore</h3>
            <ul className={styles.linkList}>
              <li>
                <a href="#packages">Packages</a>
              </li>
              <li>
                <a href="#booking-form">Book Now</a>
              </li>
              <li>
                <Link to="/cart">Cart</Link>
              </li>
              <li>
                <a href="#faq">FAQ</a>
              </li>
            </ul>
          </div>

          <div className="col-6 col-md-2">
            <h3 className={styles.heading}>Company</h3>
            <ul className={styles.linkList}>
              <li>About Us</li>
              <li>Privacy Policy</li>
              <li>Terms &amp; Conditions</li>
              <li>Careers</li>
            </ul>
          </div>

          <div className="col-12 col-md-4">
            <h3 className={styles.heading}>Contact Info</h3>
            <p className={styles.text}>📍 Al Quoz Industrial Area, Dubai, UAE</p>
            <p className={styles.text}>✉️ info@tripontourism.com</p>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.whatsappLine}
            >
              💬 +971 56 757 5811
            </a>
          </div>
        </div>

        <div className={styles.bottomRow}>
          <p className={styles.copyright}>
            Copyright &copy; {new Date().getFullYear()} Tripontourism &middot;
            Design made by{" "}
            <a
              href="https://sajjadhussain.org"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.creditLink}
            >
              Sajjad Hussain
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
